export const inputStyles = {
  '& .MuiInputBase-input': {
    paddingRight: '37px',

    '@media (max-width: 1023px)': {
      paddingRight: '18px',
    },
  },
};
